import { getStatistics as publicGetStatistics } from './innovation-assistant-v2-statistics-statistics.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getStatistics: MaybeContext<
  BuildRESTFunction<typeof publicGetStatistics> & typeof publicGetStatistics
> = /*#__PURE__*/ createRESTModule(publicGetStatistics);

export {
  ChatHandler,
  Period,
} from './innovation-assistant-v2-statistics-statistics.universal.js';
export {
  Statistics,
  Daily,
  Timespan,
  GetStatisticsRequest,
  GetStatisticsResponse,
  GetStatisticsOptions,
} from './innovation-assistant-v2-statistics-statistics.universal.js';
export {
  ChatHandlerWithLiterals,
  PeriodWithLiterals,
} from './innovation-assistant-v2-statistics-statistics.universal.js';
